import * as React from 'react';
import ButtonGroup from 'reactstrap/lib/ButtonGroup';
import '../../../styles/UnitMap.css';
import Button from '../form/Button';
import ZoomInIcon from '../../../images/zoom-in.svg';
import ZoomOutIcon from '../../../images/zoom-out.svg';
import { MapContext } from './UnitMapTypes';
import { useContext } from 'react';

const MapZoomButtons = () => {
    const context = useContext(MapContext);
    return (
        <ButtonGroup>
            <Button key={'zoom-in'} text={''} addlClassName="btn-light" suppressBottomMargin={true}>
                <img
                    className="map-control"
                    src={ZoomInIcon}
                    onClick={() => {
                        context.map.zoom(0.5);
                    }}
                />
            </Button>
            <Button
                key={'zoom-out'}
                text={''}
                addlClassName="btn-light"
                suppressBottomMargin={true}
            >
                <img
                    className="map-control"
                    src={ZoomOutIcon}
                    onClick={() => {
                        context.map.zoom(-0.5);
                    }}
                />
            </Button>
        </ButtonGroup>
    );
};
export default MapZoomButtons;



// WEBPACK FOOTER //
// ./src/components/common/UnitMap/MapZoomButtons.tsx